import React, { useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { DashboardSidebar } from '../components/DashboardSidebar';
import { NewspaperIcon, EyeIcon, TrendingUpIcon, MessageSquareIcon, PlusIcon, ArrowUpIcon, ArrowDownIcon } from 'lucide-react';
export const ReporterDashboard = () => {
  const {
    currentUser,
    userProfile
  } = useAuth();
  const [stats, setStats] = useState({
    articles: 0,
    views: 0,
    comments: 0,
    trending: 0
  });
  // Simulated data for recent articles
  const recentArticles = [{
    id: 1,
    title: 'Global Climate Agreement Reached at Summit',
    status: 'published',
    date: '2023-10-15',
    views: 1245,
    comments: 32
  }, {
    id: 2,
    title: 'Tech Giants Announce New AI Ethics Coalition',
    status: 'draft',
    date: '2023-10-14',
    views: 0,
    comments: 0
  }, {
    id: 3,
    title: 'Market Report: Stocks Surge on Economic Data',
    status: 'published',
    date: '2023-10-10',
    views: 876,
    comments: 15
  }, {
    id: 4,
    title: 'New Healthcare Policy to Take Effect Next Month',
    status: 'review',
    date: '2023-10-08',
    views: 0,
    comments: 0
  }];
  // Simulated data for performance metrics
  const performanceData = [{
    label: 'This Week',
    value: 4523,
    change: 12.5,
    isPositive: true
  }, {
    label: 'Last Week',
    value: 4021,
    change: 8.2,
    isPositive: true
  }, {
    label: 'This Month',
    value: 15642,
    change: -3.8,
    isPositive: false
  }, {
    label: 'Last Month',
    value: 16258,
    change: 22.4,
    isPositive: true
  }];
  // Simulate fetching stats
  useEffect(() => {
    // This would be replaced with actual API calls in a real application
    setStats({
      articles: 24,
      views: 15642,
      comments: 342,
      trending: 3
    });
  }, []);
  return <div className="flex h-screen bg-gray-50" data-id="element-454">
      <DashboardSidebar data-id="element-455" />
      <div className="flex-1 overflow-y-auto" data-id="element-456">
        <div className="p-8" data-id="element-457">
          <div className="mb-8" data-id="element-458">
            <h1 className="text-2xl font-bold mb-1" data-id="element-459">
              Welcome back, {userProfile?.name || 'Reporter'}
            </h1>
            <p className="text-gray-600" data-id="element-460">
              Here's what's happening with your articles today
            </p>
          </div>
          {/* Stats Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-461">
            <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-100" data-id="element-462">
              <div className="flex items-center justify-between mb-4" data-id="element-463">
                <h3 className="text-gray-500 text-sm font-medium" data-id="element-464">
                  Total Articles
                </h3>
                <div className="bg-blue-100 p-2 rounded-lg" data-id="element-465">
                  <NewspaperIcon className="h-5 w-5 text-blue-600" data-id="element-466" />
                </div>
              </div>
              <p className="text-3xl font-bold" data-id="element-467">{stats.articles}</p>
              <p className="text-green-600 text-sm mt-2 flex items-center" data-id="element-468">
                <ArrowUpIcon className="h-3 w-3 mr-1" data-id="element-469" />
                <span data-id="element-470">3 new this week</span>
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-100" data-id="element-471">
              <div className="flex items-center justify-between mb-4" data-id="element-472">
                <h3 className="text-gray-500 text-sm font-medium" data-id="element-473">
                  Total Views
                </h3>
                <div className="bg-green-100 p-2 rounded-lg" data-id="element-474">
                  <EyeIcon className="h-5 w-5 text-green-600" data-id="element-475" />
                </div>
              </div>
              <p className="text-3xl font-bold" data-id="element-476">
                {stats.views.toLocaleString()}
              </p>
              <p className="text-green-600 text-sm mt-2 flex items-center" data-id="element-477">
                <ArrowUpIcon className="h-3 w-3 mr-1" data-id="element-478" />
                <span data-id="element-479">12.5% increase</span>
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-100" data-id="element-480">
              <div className="flex items-center justify-between mb-4" data-id="element-481">
                <h3 className="text-gray-500 text-sm font-medium" data-id="element-482">Comments</h3>
                <div className="bg-purple-100 p-2 rounded-lg" data-id="element-483">
                  <MessageSquareIcon className="h-5 w-5 text-purple-600" data-id="element-484" />
                </div>
              </div>
              <p className="text-3xl font-bold" data-id="element-485">{stats.comments}</p>
              <p className="text-green-600 text-sm mt-2 flex items-center" data-id="element-486">
                <ArrowUpIcon className="h-3 w-3 mr-1" data-id="element-487" />
                <span data-id="element-488">8.3% increase</span>
              </p>
            </div>
            <div className="bg-white rounded-lg shadow-sm p-6 border border-gray-100" data-id="element-489">
              <div className="flex items-center justify-between mb-4" data-id="element-490">
                <h3 className="text-gray-500 text-sm font-medium" data-id="element-491">
                  Trending Articles
                </h3>
                <div className="bg-orange-100 p-2 rounded-lg" data-id="element-492">
                  <TrendingUpIcon className="h-5 w-5 text-orange-600" data-id="element-493" />
                </div>
              </div>
              <p className="text-3xl font-bold" data-id="element-494">{stats.trending}</p>
              <p className="text-red-600 text-sm mt-2 flex items-center" data-id="element-495">
                <ArrowDownIcon className="h-3 w-3 mr-1" data-id="element-496" />
                <span data-id="element-497">1 less than last week</span>
              </p>
            </div>
          </div>
          {/* Main Content */}
          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8" data-id="element-498">
            {/* Recent Articles */}
            <div className="lg:col-span-2" data-id="element-499">
              <div className="bg-white rounded-lg shadow-sm border border-gray-100" data-id="element-500">
                <div className="p-6 border-b border-gray-100 flex justify-between items-center" data-id="element-501">
                  <h2 className="text-lg font-bold" data-id="element-502">Recent Articles</h2>
                  <button className="flex items-center text-sm text-blue-600 hover:text-blue-800" data-id="element-503">
                    <PlusIcon className="h-4 w-4 mr-1" data-id="element-504" />
                    New Article
                  </button>
                </div>
                <div className="overflow-x-auto" data-id="element-505">
                  <table className="w-full" data-id="element-506">
                    <thead data-id="element-507">
                      <tr className="text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-508">
                        <th className="px-6 py-3" data-id="element-509">Title</th>
                        <th className="px-6 py-3" data-id="element-510">Status</th>
                        <th className="px-6 py-3" data-id="element-511">Date</th>
                        <th className="px-6 py-3" data-id="element-512">Views</th>
                        <th className="px-6 py-3" data-id="element-513">Comments</th>
                      </tr>
                    </thead>
                    <tbody className="divide-y divide-gray-100" data-id="element-514">
                      {recentArticles.map(article => <tr key={article.id} className="hover:bg-gray-50" data-id="element-515">
                          <td className="px-6 py-4" data-id="element-516">
                            <div className="font-medium text-gray-900" data-id="element-517">
                              {article.title}
                            </div>
                          </td>
                          <td className="px-6 py-4" data-id="element-518">
                            <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium
                              ${article.status === 'published' ? 'bg-green-100 text-green-800' : article.status === 'draft' ? 'bg-gray-100 text-gray-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-519">
                              {article.status.charAt(0).toUpperCase() + article.status.slice(1)}
                            </span>
                          </td>
                          <td className="px-6 py-4 text-sm text-gray-500" data-id="element-520">
                            {article.date}
                          </td>
                          <td className="px-6 py-4 text-sm text-gray-500" data-id="element-521">
                            {article.views.toLocaleString()}
                          </td>
                          <td className="px-6 py-4 text-sm text-gray-500" data-id="element-522">
                            {article.comments}
                          </td>
                        </tr>)}
                    </tbody>
                  </table>
                </div>
                <div className="p-4 border-t border-gray-100 text-center" data-id="element-523">
                  <button className="text-sm text-blue-600 hover:text-blue-800" data-id="element-524">
                    View All Articles
                  </button>
                </div>
              </div>
            </div>
            {/* Performance Metrics */}
            <div className="lg:col-span-1" data-id="element-525">
              <div className="bg-white rounded-lg shadow-sm border border-gray-100 h-full" data-id="element-526">
                <div className="p-6 border-b border-gray-100" data-id="element-527">
                  <h2 className="text-lg font-bold" data-id="element-528">Performance</h2>
                </div>
                <div className="p-6 space-y-4" data-id="element-529">
                  {performanceData.map((item, index) => <div key={index} className="flex items-center justify-between" data-id="element-530">
                      <div data-id="element-531">
                        <h4 className="text-sm font-medium text-gray-500" data-id="element-532">
                          {item.label}
                        </h4>
                        <p className="text-lg font-bold" data-id="element-533">
                          {item.value.toLocaleString()}
                        </p>
                      </div>
                      <div className={`flex items-center ${item.isPositive ? 'text-green-600' : 'text-red-600'}`} data-id="element-534">
                        {item.isPositive ? <ArrowUpIcon className="h-4 w-4 mr-1" data-id="element-535" /> : <ArrowDownIcon className="h-4 w-4 mr-1" data-id="element-536" />}
                        <span className="text-sm font-medium" data-id="element-537">
                          {Math.abs(item.change)}%
                        </span>
                      </div>
                    </div>)}
                </div>
                <div className="p-6 border-t border-gray-100" data-id="element-538">
                  <button className="w-full bg-blue-50 text-blue-600 hover:bg-blue-100 py-2 px-4 rounded-md text-sm font-medium transition-colors" data-id="element-539">
                    View Detailed Analytics
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};